/* src/app/components/doc-viewer-new/doc-viewer-bottom-right-bar/hits-panel/hits-panel.component.scss */
:host {
  height: 100%;
}
iframe {
  flex: auto;
  border: 0px;
}
.hits-content {
  color: rgba(0, 0, 0, 0.87);
}
.hits-repeater {
  border: 1px solid rgba(0, 0, 0, 0.15);
  margin: 10px 6px;
  border-radius: 4px;
}
.normalized-hits {
  position: relative;
  margin: 15px 6px 10px 6px;
}
.normalized-hits .normalized-hits-link-wrapper {
  margin: 10px 0 10px 4px;
  position: absolute;
  top: -17px;
  transition: transform linear 150ms;
}
.normalized-hits .normalized-hits-link-wrapper:hover {
  transform: scale(1.1);
}
a,
a:visited {
  color: #363636;
  background: #e1e4f3;
  border-radius: 20px;
  text-decoration: none;
  padding: 2px 6px;
  cursor: pointer;
}
.content-top {
  background: #fff;
}
.grey-header {
  background: #efefef;
  position: sticky;
  top: 10px;
  z-index: 1;
}
.icon {
  --fa-primary-color: #243e90;
  --fa-secondary-color: #a6b1d2;
  --fa-secondary-opacity: 1;
  padding-right: 4px;
}
:host-context(.dark-theme) .hits-content {
  color: #ededed;
}
:host-context(.dark-theme) .hit-text {
  color: #dbdbdb;
}
:host-context(.dark-theme) ::ng-deep b {
  color: #fff;
}
:host-context(.dark-theme) .hits-repeater {
  border: 1px solid rgba(255, 255, 255, 0.18);
}
:host-context(.dark-theme) .content-top {
  background: #252525;
}
:host-context(.dark-theme) .grey-header {
  background: #484848;
}
:host-context(.dark-theme) a,
:host-context(.dark-theme) a:visited {
  color: #c9c9c9;
  background: #000;
}
:host-context(.dark-theme) .icon {
  --fa-primary-color: #FFC107;
  --fa-secondary-color: #6c6c6c;
}
/*# sourceMappingURL=hits-panel.component.css.map */
